import moment from 'moment'
import Shortid from 'shortid'

const resumeTemplate = {
  productTemplate: '',
  id: -1,
  fields: {
    title: 'Untitled',
    fixed: {
      personalDetails: {
        label: 'Personal Details',
        hint: '',
        help: '',
        show: true,
        children: [
          {
            value: 'Type your name here',
            label: 'Name',
            hint: '',
            help: ''
          },
          {
            value: '+60 - XXX - XXXX',
            label: 'Phone',
            hint: '',
            help: ''
          },
          {
            value: 'youremail@yourdomain.com',
            label: 'Email',
            hint: '',
            help: ''
          },
          {
            value: 'Your address (if applicable)',
            label: 'Address',
            hint: '',
            help: ''
          },
          {
            value: 'January 1, 1960',
            label: 'Date Of Birth',
            hint: '',
            help: ''
          }
        ]
      },
      professionalSummary: {
        label: 'Career Objective',
        show: true,
        hint: '',
        help: '',
        children: {
          summary: {
            value: 'Seeking a challenging career with a progressive organization that provides an opportunity to capitalize my technical skills & abilities in the field of information technology  (IT)',
            label: 'Include 2-3 sentences about your goals',
            hint: '',
            help: ''
          }
        }
      }
    },
    relatives: [
      {
        id: 'skillsTech', // unique
        label: 'Technical Skills',
        singleName: 'technical skill',
        showExperienceLevel: false, // special for Skills part
        required: true,
        childrens: [
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Hardware troubleshooting',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Network troubleshooting',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Programming (Java, C++, Visual Basic, Android Programming Language)',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Microsoft Office (MS Word, Excel, Powerpoint, Internet, etc)',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          }
        ]
      },
      {
        id: 'skillsPersonal', // unique
        label: 'Personal Skills',
        singleName: 'personal skill',
        showExperienceLevel: false, // special for Skills part
        required: true,
        childrens: [
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Excellent written and verbal communication skills',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Highly organized and efficient',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Ability to work independently or as part of a team',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Proven leadership skills and ability to motivate',
                label: 'Skill',
                hint: '',
                help: ''
              }
            ]
          }
        ]
      },
      {
        id: 'education', // unique
        label: 'Education',
        singleName: 'education',
        showExperienceLevel: false, // special for Skills part
        required: true,
        // help: '',
        childrens: [
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'B.Sc in Computer Science',
                label: 'Degree',
                hint: '',
                help: ''
              },
              {
                type: 'date',
                value: [
                  moment().set({
                    year: 2017
                  }),
                  moment().set({
                    year: 2019
                  })
                ],
                label: 'Start & End Date',
                hint: '',
                help: ''
              },
              {
                type: 'text',
                value: 'Majoring in Artificial Intelligence',
                label: 'Major',
                hint: '',
                help: ''
              },
              {
                type: 'text',
                value: 'Xxxxxxxxxxxx University',
                label: 'School',
                hint: '',
                help: ''
              },
              {
                type: 'select',
                select: 'certificates',
                value: '',
                label: 'Certificate',
                hint: '',
                help: ''
              }
            ]
          }
        ]
      },
      {
        id: 'achievements', // unique
        label: 'Achievements/Responsibilities',
        singleName: 'achievement/responsibility',
        showExperienceLevel: false, // special for Skills part
        required: true,
        childrens: [
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'President, Association of Computer Students (2014 - 2015)',
                label: 'Acheivement',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Lay-out Artist, The Guardian Student Magazine (2012 - 2014)',
                label: 'Acheivement',
                hint: '',
                help: ''
              }
            ]
          },
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Vice-Governor, College of Engineering and Science',
                label: 'Acheivement',
                hint: '',
                help: ''
              }
            ]
          }
        ]
      },
      {
        id: 'employmentHistory', // unique
        label: 'Professional Experience',
        singleName: 'employment',
        showExperienceLevel: false, // special for Skills part
        required: true,
        childrens: [
          { // the key is the same as relative id
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Technical Support Intern',
                label: 'Job Title',
                hint: '',
                help: ''
              },
              {
                type: 'text',
                value: 'IT Department',
                label: 'Department',
                hint: '',
                help: ''
              },
              {
                type: 'text',
                value: 'Xerox Business Services\'s Inc.',
                label: 'Employer',
                hint: '',
                help: ''
              },
              {
                type: 'date',
                value: [
                  moment().set({
                    year: 2014,
                    month: 5
                  }),
                  moment({
                    year: 2015,
                    month: 1
                  })
                ],
                label: 'Start & End Date',
                hint: '',
                help: ''
              },
              {
                type: 'description',
                value: 'Provided Level 1 support, handled troubleshooting and maintenance as well as monitoring and deployment of IT equipment.',
                label: 'Description',
                hint: '',
                help: ''
              }
            ]
          }
        ]
      },
      {
        id: 'references', // unique
        label: 'References',
        singleName: 'reference',
        showExperienceLevel: false, // special for Skills part
        required: false,
        childrens: [
          {
            id: Shortid.generate(),
            titleId: 0,
            fields: [
              {
                type: 'text',
                value: 'Available upon request',
                label: 'Reference\'s Full Name',
                hint: '',
                help: ''
              }
            ]
          }
        ]
      }
    ]
  },
  description: ''
}

const resumeChildrenTemplate = {
  skillsTech: {
    id: '',
    titleId: 0,
    fields: [
      {
        type: 'text',
        value: '',
        label: 'Skill',
        hint: 'Hardware troubleshooting',
        help: ''
      }
    ]
  },
  skillsPersonal: {
    id: '',
    titleId: 0,
    fields: [
      {
        type: 'text',
        value: '',
        label: 'Skill',
        hint: 'Excellent written and verbal communication skills',
        help: ''
      }
    ]
  },
  education: {
    id: '',
    titleId: 0,
    fields: [
      {
        type: 'text',
        value: '',
        label: 'Degree',
        hint: '',
        help: ''
      },
      {
        type: 'date',
        value: [moment(), moment()],
        label: 'Start & End Date',
        hint: '',
        help: ''
      },
      {
        type: 'text',
        value: '',
        label: 'Major',
        hint: '',
        help: ''
      },
      {
        type: 'text',
        value: '',
        label: 'School',
        hint: '',
        help: ''
      },
      {
        type: 'select',
        select: 'certificates',
        value: '',
        label: 'Certificate',
        hint: '',
        help: ''
      }
    ]
  },
  achievements: {
    id: '',
    titleId: 0,
    fields: [
      {
        type: 'text',
        value: '',
        label: 'Acheivement',
        hint: 'President, Association of Computer Students (2014 - 2015)',
        help: ''
      }
    ]
  },
  employmentHistory: { // the key is the same as relative id
    id: '',
    titleId: 0,
    fields: [
      {
        type: 'text',
        value: '',
        label: 'Job Title',
        hint: 'Technical Support Intern',
        help: ''
      },
      {
        type: 'text',
        value: '',
        label: 'Department',
        hint: 'IT Department',
        help: ''
      },
      {
        type: 'text',
        value: '',
        label: 'Employer',
        hint: 'Xerox Business Services\'s Inc.',
        help: ''
      },
      {
        type: 'date',
        value: [moment(), moment()],
        label: 'Start & End Date',
        hint: '',
        help: ''
      },
      {
        type: 'description',
        value: '',
        label: 'Description',
        hint: '',
        help: ''
      }
    ]
  },
  references: {
    id: '',
    titleId: 0,
    fields: [
      {
        type: 'text',
        value: '',
        label: 'Reference\'s Full Name',
        hint: 'Available upon request',
        help: ''
      }
    ]
  }
}

export { resumeTemplate, resumeChildrenTemplate }



// WEBPACK FOOTER //
// ./src/views/resumeBuilder/sampleData.js